import request from "@/utils/request";
import { uploadFile } from "@/utils/request";

// 根据用户token生成聊天记录
export function createChatSession(data) {
    return request({
        url: "MiniProgramApi/CreateChatSession",
        method: "post",
        data
    });
}

export function getHistoryMessage(data){
    return request({
        url: "MiniProgramApi/GetHistoryMessage",
        method: "post",
        data
    });
}

// 获取用户详情
export function getMemberDetail(id){
    return request({
        url: "MiniProgramApi/GetByMemberId",
        method: "get",
        params: {
            memberId: id
        }
    });
}

// 更新用户信息
export function updateMemberInfo(data) {
    return request({
        url: "MiniProgramApi/UpdateUserMessage",
        method: "post",
        data
    });
}

// 上传用户头像
export function uploadPic(data, file) {
    return uploadFile("Common/UploadPic", data, file);
}